import { useState } from "react";

const testimonials = [
  {
    id: 1,
    name: "João Silva",
    location: "Lisboa, Portugal",
    rating: 4.9,
    text: "A planilha CSSBuy mudou completamente a minha experiência de compras da China. Os links são sempre atualizados e os vendedores são realmente confiáveis. Recomendo a todos que querem comprar com segurança.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20young%20man%20warm%20smile%2C%20clean%20cream%20background%2C%20soft%20window%20light%2C%20minimalist%20headshot%2C%20friendly%20expression%2C%20casual%20linen%20shirt%2C%20high%20quality%20portrait&width=120&height=120&seq=avatar-joao-v2&orientation=squarish",
  },
  {
    id: 2,
    name: "Maria Costa",
    location: "Porto, Portugal",
    rating: 5.0,
    text: "Uso a CSSBuy há mais de 2 anos e esta planilha é de longe a melhor que já encontrei. As categorias são bem organizadas e os guias em português fazem toda a diferença para quem está a começar.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20young%20woman%20confident%20smile%2C%20clean%20cream%20background%2C%20soft%20window%20light%2C%20minimalist%20headshot%2C%20elegant%20casual%20blouse%2C%20warm%20friendly%20expression%2C%20high%20quality%20portrait&width=120&height=120&seq=avatar-maria-v2&orientation=squarish",
  },
  {
    id: 3,
    name: "Pedro Oliveira",
    location: "São Paulo, Brasil",
    rating: 4.8,
    text: "Finalmente uma planilha em português! Moro no Brasil e sempre tive dificuldade em encontrar informações confiáveis sobre CSSBuy. Este site resolveu todos os meus problemas. A secção de FAQ é excelente.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20man%20genuine%20warm%20smile%2C%20clean%20cream%20background%2C%20soft%20window%20light%2C%20minimalist%20headshot%2C%20friendly%20expression%2C%20casual%20cotton%20shirt%2C%20high%20quality%20portrait&width=120&height=120&seq=avatar-pedro-v2&orientation=squarish",
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col items-center text-center max-w-2xl mx-auto">
          <span className="text-primary-600 text-sm font-medium">
            Especialista em Compras da China
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
            O Que Dizem os Nossos Utilizadores
          </h2>

          <div className="mt-10 bg-white rounded-3xl p-8 md:p-12 w-full relative">
            <div className="flex items-center justify-center gap-1 mb-6">
              <span className="bg-foreground-950 text-accent-500 text-xs font-bold px-3 py-1 rounded-full inline-flex items-center gap-1 whitespace-nowrap">
                <i className="ri-star-fill text-xs"></i> {t.rating}
              </span>
            </div>

            <blockquote className="text-foreground-700 text-base md:text-lg leading-relaxed italic">
              &ldquo;{t.text}&rdquo;
            </blockquote>

            <div className="flex items-center justify-center gap-3 mt-8">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={t.avatarUrl}
                  alt={t.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-left">
                <div className="text-foreground-950 font-semibold text-sm">
                  {t.name}
                </div>
                <div className="text-foreground-500 text-xs">{t.location}</div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-3 mt-8">
              <button
                onClick={prev}
                className="w-10 h-10 rounded-full border-2 border-background-300 flex items-center justify-center cursor-pointer hover:border-foreground-400 transition-all duration-200"
                aria-label="Depoimento anterior"
              >
                <i className="ri-arrow-left-s-line text-foreground-600"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center cursor-pointer hover:bg-foreground-800 transition-all duration-200"
                aria-label="Próximo depoimento"
              >
                <i className="ri-arrow-right-s-line text-white"></i>
              </button>
            </div>
          </div>

          <div className="mt-12 text-foreground-600 text-sm max-w-lg">
            <p>
              <strong className="text-foreground-950">Mais de 5 anos de experiência</strong> em
              compras da China. Conteúdo baseado em pesquisa e experiência
              prática. Atualizado regularmente para garantir a melhor informação.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}